var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79167 11H20.2083C20.6456 11 21 11.4253 21 11.95V12.05C21 12.5747 20.6456 13 20.2083 13H6.79167C6.35444 13 6 12.5747 6 12.05V11.95C6 11.4253 6.35444 11 6.79167 11Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5278 16H20.4722C20.7637 16 21 16.4253 21 16.95V17.05C21 17.5747 20.7637 18 20.4722 18H11.5278C11.2363 18 11 17.5747 11 17.05V16.95C11 16.4253 11.2363 16 11.5278 16Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95 6H20.05C20.5747 6 21 6.42533 21 6.95V7.05C21 7.57467 20.5747 8 20.05 8H3.95C3.42533 8 3 7.57467 3 7.05V6.95C3 6.42533 3.42533 6 3.95 6Z",
    fill: "#1A1A1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOutline);
export default __webpack_public_path__ + "static/media/menu-outline.b109cfc674af93280caff080e1bea4ab.svg";
export { ForwardRef as ReactComponent };